// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c0f8ca20/" + chunkId + "." + __webpack_require__.h() + ".vc0f8ca20.js";
};